export enum TABLE_CELL_ALIGN {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
  INHERIT = 'inherit',
  JUSTIFY = 'justify',
}

export enum SORT_DIRECTION {
  DEFAULT = '',
  ASC = 'asc',
  DESC = 'desc',
}
